import React, { useState, useEffect } from 'react'
import TextInputBox from './TextInputBox'
import { CreateUrl, CallGetAPI, CallDeleteAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import DOMPurify from 'dompurify'
import { Button, Avatar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import moment from 'moment'
import { FormattedMessage, useIntl, IntlShape } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import Loader from '../../Utils/Loader/NewLoader2025'
import { useMobileContext } from '../../Context/ContextProvider'
import FullWidthMobileButton from '../FullWidthMobileButton';
interface Props {
    loggerId: number | null
    lcLoggerId: number | null
    siteId: number | null

}

interface CommentData {
    commentText: string
    created: Date
    email: string
    fkLcloggerId: number | null | undefined
    fkSiteId: number | null
    fkLoggerId: number | null
    id: number
}

interface EmailColor {
    email: string | null
    color: string | null
}
const Comments: React.FC<Props> = ({ loggerId, lcLoggerId, siteId}) => {

    locale(sessionStorage.getItem('language'));
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);
    const isMobile = useMobileContext()
    const intl = useIntl()
    const [comment, setComment ] = useState<string>("")
    const [commentData, setCommentData] = useState<Array<CommentData>>([])
    const [emailColors, setEmailColors] = useState<Array<EmailColor>>([])
    const [loading, setLoading] = useState<boolean>(true)
    useEffect(() => reloadData(), [])
    const handleCommentChange = (e):void => {
        setComment(e.value)

    }

    const overViewStyle = {
        backgroundColor: "#f7f7f7",
        borderRadius: "5px",
        padding: "10px 0 0 0",
        width: "100%",
        boxShadow: "2px 2px 10px #00000060",
        marginBottom: "30px",
        cursor: "pointer",
        justifyContent: "center",
        alignItems: "center"
    }


    const reloadData = ():void => {

        if (lcLoggerId) {
            CallGetAPI(CreateUrl(`/api/aquaguard/Comments?lcLoggerId=${lcLoggerId - 500000}`), {})
                .then(data => {
                    setCommentData(purifyText(data))
                    setLoading(false)
                }) 
        }
        if (loggerId) {
            CallGetAPI(CreateUrl(`/api/aquaguard/Comments?loggerId=${loggerId}`), {})
                .then(data => {
                    setCommentData(purifyText(data))
                    setLoading(false)
                })
        }
        if (siteId) {
            CallGetAPI(CreateUrl(`/api/aquaguard/Comments?siteId=${siteId}`), {})
                .then(data => {
                    setCommentData(purifyText(data))
                    setLoading(false)
                })
        }
        
       
    }

    const purifyText = (array: Array<CommentData>):Array<CommentData> => {
        const purifiedData = array.map(commentData => {
            commentData.commentText = DOMPurify.sanitize(commentData.commentText)
            return commentData
        })
        return purifiedData
    }

    useEffect(() => {
        const uniqueEmails: Array<string> = []
        const uniqueColors = []
        if (commentData.length > 0) {
            commentData.forEach(data => {

                if (!uniqueEmails.includes(data.email)) {
                    uniqueEmails.push(data.email)
                }
            })
            uniqueEmails.forEach(email => {
                uniqueColors.push({ email: email, color: '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0') })
            })
            setEmailColors(uniqueColors)
        }

    }, [commentData])

    const handleDeleteClick = (id: number): void => {
        let confirm = false
        if (!isMobile) {
            confirm = window.confirm(intl.formatMessage({ id: 'Are you sure you want to delete this comment?' }))
        } else {
            confirm = true
        }
        console.log(id, confirm)
        if (confirm) {
            CallDeleteAPI(CreateUrl(`/api/aquaguard/Comments?id=${id}`), {})
                .then(data => {
                    createSuccessNotification()
                    setTimeout(() => reloadData(), 500)
                })
                .catch(err => {
                    console.log(err)
                    createErrorNotification()
                })
        }
    }

    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }));

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Contact Administrator' }), 5000, () => {
            alert(intl.formatMessage({ id: 'Contact Administrator' }));
        });
    };

    const handleSaveComment = (): void => {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email: sessionStorage.getItem('userName'),
                fkLcLoggerId: lcLoggerId ? lcLoggerId - 500000 : null,
                fkLoggerId: loggerId,
                fkSiteId: siteId,
                comment: DOMPurify.sanitize(comment)
            })
        }
        console.log(requestOptions)
        CallPostAPI(CreateUrl(`/api/aquaguard/Comments`), requestOptions)
            .then(data => {
                createSuccessNotification()
                setTimeout(() => reloadData(), 500)
                setComment("")
            })
            .catch(err => console.log(err))
    }
    


    return (
        <>
        {loading &&
        <div style={{
            position: 'absolute', left: 'Calc(50% - 100px)', top: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 13000
        }}>
            <Loader color={undefined} />
        </div>}
            {!loading && <div>
                {commentData.length > 0 && commentData.map((item, idx) => {
                    const color = emailColors?.filter(i => i.email === item.email)[0]?.color
                    return (<>


                        {!loading && <div key={idx} style={{ borderLeft: `10px solid ${color}`, ...overViewStyle, padding: "20px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex" }}>
                                    <Avatar></Avatar>
                                    <div style={{ margin: "-6px 0 0 10px" }}>
                                        <h4 ><b>{item.email}</b></h4>
                                        <p style={{ marginTop: "-8px" }}>{moment(item.created).format('DD MMM YYYY HH:mm:ss')}</p>
                                    </div>
                                </div>
                                {sessionStorage.getItem('canConfig') === 'true' && <div>
                                    <Button variant="contained" onClick={() => handleDeleteClick(item.id)} style={{ borderRadius: "50%", width: "40px", height: "40px", minWidth: "unset", }}><CloseIcon /></Button>
                                </div>}
                            </div>
                            <div style={{ display: "block", margin: "20px 0" }} dangerouslySetInnerHTML={{ __html: item.commentText }} />
                        </div>}
                    </>)
                })}

                <TextInputBox currentText={comment} handleTextChange={handleCommentChange} />
                {isMobile ? <div style={{ width: "100%", marginTop: "20px" }}><FullWidthMobileButton color="primary" onClick={(): void => handleSaveComment()} text={intl.formatMessage({ id: "Save Comment" })} /></div> :
                    <Button variant="contained" style={{ float: "right", marginTop: "20px" }} onClick={(): void => handleSaveComment()}><FormattedMessage id="Save Comment" /></Button>}
            </div>}
        </>
    ) 
}
export default Comments